import { TravelTypeEnum } from './generated/graphql'

export type TravelTypeWithHousing =
  | TravelTypeEnum.DAILY_TRIP
  | TravelTypeEnum.NIGHTLY_TRIP
  | TravelTypeEnum.CORPORATE_EVENING_EVENT

export const TRAVEL_TYPE_WITH_HOUSING: TravelTypeWithHousing[] = [
  TravelTypeEnum.DAILY_TRIP,
  TravelTypeEnum.NIGHTLY_TRIP,
  TravelTypeEnum.CORPORATE_EVENING_EVENT,
]

export const isTravelTypeWithHousing = (
  value: TravelTypeEnum,
): value is TravelTypeWithHousing => {
  return TRAVEL_TYPE_WITH_HOUSING.includes(value as TravelTypeWithHousing)
}
